import $ from "jquery";

// smooth scroll
const smoothScroll = () => {
	// idを指定しているaタグを全て取得
	const anchorLink = document.querySelectorAll('a[href^="#"]');
	// headerを取得
	const header = document.querySelector('header');
	// headerがあればヘッダーの高さを定義、そうでなければ0を定義
	const headerHeight = header ? header.offsetHeight : 0;

	for (let i = 0; i < anchorLink.length; i++) {
		anchorLink[i].addEventListener('click', (e) => {
			// aタグのイベントを止める
			e.preventDefault();

			const href = anchorLink[i].getAttribute("href");
			const target = document.querySelector(href);
			const position = window.pageYOffset + target.getBoundingClientRect().top - headerHeight;
			const speed = 500;

			// ie対応のためにjQueryでスムーススクロールを制御
			// できればjQueryやめたい
			$("html, body").animate({
				scrollTop: position
			}, speed, "swing");
		})
	}
};

const headerSpaceingCtrl = () => {
	const header = document.querySelector('header');
	const body = document.querySelector('body');
	const addHeaderSpaceClass = 'header-auto-space';
	const headerHeight = header.clientHeight;

	body.style.paddingTop = `${headerHeight}px`;
}

const menuScript = () => {
	const trigger = document.querySelector('#menu-trigger');
	const spNav = document.querySelector('#spNav');
	const spNavBtn = document.querySelectorAll('.sp-anchor-link');

	trigger.addEventListener('click', () => {
		if (trigger.classList.contains('is_set')) {
			trigger.classList.remove('is_set');
			spNav.classList.remove('is_set');
		} else {
			trigger.classList.add('is_set');
			spNav.classList.add('is_set');
		}
	})

	for (let i = 0; i < spNavBtn.length; i++) {
		spNavBtn[i].addEventListener('click', () => {
			trigger.classList.remove('is_set');
			spNav.classList.remove('is_set');
		})
	}
}

//下から表示させる要素を指定
let $pagetop = $('.top-btn-link');

$(window).on( 'scroll', function () {
  //スクロール位置を取得
  if ( $(this).scrollTop() < 1200 ) {
	$pagetop.removeClass('isActive');
  } else {
	$pagetop.addClass('isActive');
  }
});
window.addEventListener('load', () => {
	smoothScroll();
	headerSpaceingCtrl();
	menuScript();
})



